"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ipfsHttpClient = _interopRequireDefault(require("ipfs-http-client"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * A Class used for uploading/adding files to IPFS
 */


var IpfsHttpApi = /*#__PURE__*/function () {
  /**
   * Create a new IPFS Node.js Add
   *
   * @param {Buffer|ReadableStream|PullStream} file - The [File](https://developer.mozilla.org/en-US/docs/Web/API/File) or [Blob](https://developer.mozilla.org/en-US/docs/Web/API/Blob) you want added to IPFS.
   * @param {Object} options - The Options for this Upload
   * @param {String} options.host - The hostname of the IPFS API server to upload to (i.e. "ipfs-dev.alexandria.io")
   * @param {String} options.protocol - The Protocol of the IPFS API server to upload to (i.e. "https")
   * @param {Number} options.port - The Port of the IPFS API server to upload to (i.e. `443`)
   * @param {Object} options.oip_auth - An object that contains a signed message, the address that signed the message, and the signature for them both
   * @param {String} [options.filename] - The filename/path of the Item you are uploading
   * @param {String} [options.filesize] - The size of the Item you are uploading. You must include this if you want valid progress reports.
   *
   * @example
   * let uploader = new IPFSNodejsAdd(file_readable_stream, {
   *  "filename": "example_file.mp4",
   *  "host": "ipfs-dev.alexandria.io",
   *  "protocol": "https",
   *  "port": 443,
   *  "oip_auth": {
   *    address:"oNRs1nuR1vUAjWJwhMtxJPQoTFAm9MWz1G",
   *    message:'1534278675842{"oip042":{}}',
   *    signature:"Hw2iuomv/fhYYoKX8bNroVXmOvbh/e9gqZjP+I9kZymHD72mqtDw1qjN6/Qh4nhTDOHI8mkxbWtsaLSTuCkSihU="
   *  }
   * })
   */
  function IpfsHttpApi(file, options) {
    _classCallCheck(this, IpfsHttpApi);

    this.file = file;
    this.options = options;
    this.ipfs = new _ipfsHttpClient.default({
      host: options.host,
      port: options.port,
      protocol: options.protocol,
      headers: {
        'OIP-Auth': JSON.stringify(options.oip_auth)
      }
    });
    this.progressSubscribers = [];
  }
  /**
   * Subscribe to upload Progress events
   * @param  {Function} progress_function - The function you want called when there is a progress update available
   *
   * @example
   * let uploader = new IPFSBrowserAdd(input.files[0], {
   *  "api_url": "https://ipfs-dev.alexandria.io",
   *  "oip_auth": {
   *    address:"oNRs1nuR1vUAjWJwhMtxJPQoTFAm9MWz1G",
   *    message:'1534278675842{"oip042":{}}',
   *    signature:"Hw2iuomv/fhYYoKX8bNroVXmOvbh/e9gqZjP+I9kZymHD72mqtDw1qjN6/Qh4nhTDOHI8mkxbWtsaLSTuCkSihU="
   *  }
   * })
   *
   * uploader.onProgress((progress_message) => {
   *  console.log("Progress! " + JSON.stringify(progress_message))
   * })
   */


  _createClass(IpfsHttpApi, [{
    key: "onProgress",
    value: function onProgress(progressFunction) {
      this.progressSubscribers.push(progressFunction);
    }
    /**
     * Start the File Upload to the server
     * @return {Promise<Object>} Returns a Promise that will resolve to the IPFS Added object JSON
     *
     * @example
     * let uploader = new IPFSBrowserAdd(input.files[0], {
     *  "api_url": "https://ipfs-dev.alexandria.io",
     *  "oip_auth": {
     *    address:"oNRs1nuR1vUAjWJwhMtxJPQoTFAm9MWz1G",
     *    message:'1534278675842{"oip042":{}}',
     *    signature:"Hw2iuomv/fhYYoKX8bNroVXmOvbh/e9gqZjP+I9kZymHD72mqtDw1qjN6/Qh4nhTDOHI8mkxbWtsaLSTuCkSihU="
     *  }
     * })
     *
     * uploader.onProgress((progress_message) => {
     *  console.log("Progress! " + JSON.stringify(progress_message))
     * })
     *
     * uploader.start().then((success_response) => {
     *  console.log("Upload Complete! " + JSON.stringify(success_response))
     * })
     */

  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var fileObject, onProgressFunc, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fileObject = {
                  path: this.options.filename || '',
                  content: this.file
                };

                onProgressFunc = function onProgressFunc(bytesAdded) {
                  var progressObject = {
                    bytes_uploaded: bytesAdded
                  };

                  if (_this.options.filesize) {
                    var percent = parseFloat((bytesAdded / _this.options.filesize * 100).toFixed(2));
                    progressObject.uploadProgress = percent;
                    progressObject.bytesTotal = _this.options.filesize;
                  }

                  var _iterator = _createForOfIteratorHelper(_this.progressSubscribers),
                      _step;

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      var progressFunction = _step.value;
                      progressFunction(progressObject);
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                };

                _context.prev = 2;
                _context.next = 5;
                return this.ipfs.add(fileObject, {
                  progress: onProgressFunc
                });

              case 5:
                response = _context.sent;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](2);
                throw new Error("Failed to add file to ipfs: ".concat(_context.t0));

              case 11:
                return _context.abrupt("return", response[0]);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }]);

  return IpfsHttpApi;
}();

var _default = IpfsHttpApi;
exports.default = _default;